module.exports = __webpack_public_path__ + "media/bg_health_infoanim_anim_women.5506f3e6.mp4";